// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__35qL1","label":"Category_label__1bgSX","content":"Category_content__cy9v3","header":"Category_header__1tYd-","location":"Category_location__1z5U3"};